import { VesselOptions } from './object'

function removeVesselAttrs({ $el, vessels }) {
  if ($el && $el.hasAttribute && vessels) {
    const { attrs } = vessels

    attrs.forEach(name => {
      if ($el.hasAttribute(name)) {
        $el.removeAttribute(name)
      }
    })
  }
}

export default {
  created() {
    const options = this.$options.vessel
    this.$vessels = {}

    if (options) {
      this.vessels = new VesselOptions({
        context: this,
        options: options
      })

      Object.keys(options).forEach(key => {
        Object.defineProperty(this.$vessels, key, {
          get: () => this.vessels.vessel(key)
        })
      })
    }
  },
  mounted() {
    removeVesselAttrs(this)
  },
  updated() {
    removeVesselAttrs(this)
  }
}
